export const dmeditorFields = {
  page: "full_body",
  article: "fullbody",
  template: "body",
  site: "full_body",
};
